(function () {
  if (window.__LBP_INIT) return;
  window.__LBP_INIT = true;

  var CFG = window.__LBP_CONFIG || {};
  if (!CFG.token) return;

  var STR = CFG.strings || {};

  function t(key, fallback) {
    var v = STR[key];
    return (v !== undefined && v !== null && v !== '') ? v : fallback;
  }

  var API = location.origin + '/api/' + CFG.apiVersion + '/graphql.json';

  var root = null;
  var lastFocus = null;
  var activeSourceHandle = '';
  var variantCache = {};
  var loadingCache = {};
  var carousel = { idx: 0, count: 0, bundles: [] };
  var state = { v: null, bundles: [], selectedIdx: 0 };
  var titleDefaultHTML = '';
  var eyebrowDefaultText = '';
  var addItemOnlyDefaultText = '';

  function gql(query, variables) {
    return fetch(API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': CFG.token
      },
      body: JSON.stringify({
        query: query,
        variables: variables
      })
    }).then(function (r) {
      return r.json();
    });
  }

  function numId(gid) {
    return String(gid || '').split('/').pop();
  }

  function variantGid(id) {
    var str = String(id || '');
    if (str.indexOf('gid://') === 0) return str;
    return 'gid://shopify/ProductVariant/' + str;
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function money(m) {
    if (!m) return '';

    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: m.currencyCode
      }).format(parseFloat(m.amount));
    } catch (e) {
      return '$' + m.amount;
    }
  }

  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 500);
  }

  function q(sel) {
    return root.querySelector('[data-lbp="' + sel + '"]');
  }

  var VARIANT_QUERY = '\
    query ($id: ID!) {\
      node(id: $id) {\
        ... on ProductVariant {\
          id\
          title\
          availableForSale\
          requiresComponents\
          price { amount currencyCode }\
          image { url altText }\
          variantBundles: metafield(namespace: "custom", key: "bundle_upsells") {\
            references(first: 10) {\
              nodes {\
                ... on Product {\
                  title\
                  handle\
                  onlineStoreUrl\
                  featuredImage { url altText }\
                  variants(first: 1) {\
                    nodes {\
                      id\
                      availableForSale\
                      price { amount currencyCode }\
                      compareAtPrice { amount currencyCode }\
                    }\
                  }\
                }\
              }\
            }\
          }\
          variantOffers: metafield(namespace: "custom", key: "popup_offers") {\
            references(first: 10) {\
              nodes {\
                ... on Metaobject {\
                  id\
                  offerType: field(key: "offer_type") { value }\
                  discountPercent: field(key: "discount_percent") { value }\
                  priorityField: field(key: "priority") { value }\
                  activeField: field(key: "active") { value }\
                  checklistField: field(key: "checklist") { value }\
                  headlineRef: field(key: "headline") {\
                    reference {\
                      ... on Metaobject {\
                        template: field(key: "template") { value }\
                      }\
                    }\
                  }\
                  primaryVariantRef: field(key: "primary_variant") {\
                    reference {\
                      ... on ProductVariant {\
                        id\
                        title\
                        availableForSale\
                        price { amount currencyCode }\
                        compareAtPrice { amount currencyCode }\
                        image { url altText }\
                        product { title handle featuredImage { url altText } }\
                      }\
                    }\
                  }\
                  addonVariantsField: field(key: "addon_variants") {\
                    references(first: 25) {\
                      nodes {\
                        ... on ProductVariant {\
                          id\
                          title\
                          availableForSale\
                          price { amount currencyCode }\
                          image { url altText }\
                          product { title handle featuredImage { url altText } }\
                        }\
                      }\
                    }\
                  }\
                }\
              }\
            }\
          }\
          product {\
            title\
            handle\
            featuredImage { url altText }\
            manualBundles: metafield(namespace: "custom", key: "bundle_upsells") {\
              references(first: 10) {\
                nodes {\
                  ... on Product {\
                    title\
                    handle\
                    onlineStoreUrl\
                    featuredImage { url altText }\
                    variants(first: 1) {\
                      nodes {\
                        id\
                        availableForSale\
                        price { amount currencyCode }\
                        compareAtPrice { amount currencyCode }\
                      }\
                    }\
                  }\
                }\
              }\
            }\
            productOffers: metafield(namespace: "custom", key: "popup_offers") {\
              references(first: 10) {\
                nodes {\
                  ... on Metaobject {\
                    id\
                    offerType: field(key: "offer_type") { value }\
                    discountPercent: field(key: "discount_percent") { value }\
                    priorityField: field(key: "priority") { value }\
                    activeField: field(key: "active") { value }\
                    checklistField: field(key: "checklist") { value }\
                    headlineRef: field(key: "headline") {\
                      reference {\
                        ... on Metaobject {\
                          template: field(key: "template") { value }\
                        }\
                      }\
                    }\
                    primaryVariantRef: field(key: "primary_variant") {\
                      reference {\
                        ... on ProductVariant {\
                          id\
                          title\
                          availableForSale\
                          price { amount currencyCode }\
                          compareAtPrice { amount currencyCode }\
                          image { url altText }\
                          product { title handle featuredImage { url altText } }\
                        }\
                      }\
                    }\
                    addonVariantsField: field(key: "addon_variants") {\
                      references(first: 25) {\
                        nodes {\
                          ... on ProductVariant {\
                            id\
                            title\
                            availableForSale\
                            price { amount currencyCode }\
                            image { url altText }\
                            product { title handle featuredImage { url altText } }\
                          }\
                        }\
                      }\
                    }\
                  }\
                }\
              }\
            }\
          }\
          groupedBy(first: 25) {\
            nodes {\
              id\
              availableForSale\
              price { amount currencyCode }\
              compareAtPrice { amount currencyCode }\
              components(first: 10) {\
                nodes {\
                  quantity\
                  productVariant {\
                    product { title }\
                  }\
                }\
              }\
              product {\
                title\
                handle\
                onlineStoreUrl\
                featuredImage { url altText }\
              }\
            }\
          }\
        }\
      }\
    }';

  function loadVariant(variantId) {
    var key = String(variantId || '');
    if (!key) return Promise.resolve(null);

    if (variantCache[key]) {
      return Promise.resolve(variantCache[key]);
    }

    if (loadingCache[key]) {
      return loadingCache[key];
    }

    loadingCache[key] = gql(VARIANT_QUERY, {
      id: variantGid(key)
    }).then(function (res) {
      delete loadingCache[key];

      if (!res || res.errors || !res.data || !res.data.node) {
        return null;
      }

      variantCache[key] = res.data.node;
      return variantCache[key];
    }).catch(function () {
      delete loadingCache[key];
      return null;
    });

    return loadingCache[key];
  }

  function bundlesFromMetafieldRefs(mf) {
    var refs = mf && mf.references && mf.references.nodes;
    if (!refs || !refs.length) return [];

    var out = [];

    refs.forEach(function (p) {
      var variant = p && p.variants && p.variants.nodes && p.variants.nodes[0];
      if (!variant) return;

      out.push({
        id: variant.id,
        availableForSale: variant.availableForSale,
        price: variant.price,
        compareAtPrice: variant.compareAtPrice,
        product: {
          title: p.title,
          handle: p.handle,
          onlineStoreUrl: p.onlineStoreUrl,
          featuredImage: p.featuredImage
        }
      });
    });

    return out;
  }

  // Variant-level custom.bundle_upsells (set on a specific shade) wins when
  // present, so a bundle can be scoped to only certain shades of a product.
  // Falls back to the product-level metafield for "applies to every shade".
  function manualBundlesFromMetafield(v) {
    var variantBundles = bundlesFromMetafieldRefs(v && v.variantBundles);
    if (variantBundles.length) return variantBundles;

    var product = v && v.product;
    return bundlesFromMetafieldRefs(product && product.manualBundles);
  }

  function numOrDefault(val, fallback) {
    var n = parseFloat(val);
    return isNaN(n) ? fallback : n;
  }

  // Maps one custom.popup_offers Metaobject node (offer_type: "bundle" | "addon")
  // into a plain offer object. Returns null when inactive or when required
  // references are missing (e.g. an addon offer with no available shades).
  function offerFromMetaobject(mo) {
    if (!mo) return null;

    var active = mo.activeField && mo.activeField.value;
    if (active === 'false') return null;

    var offerType = (mo.offerType && mo.offerType.value) || '';
    var discountPercent = numOrDefault(mo.discountPercent && mo.discountPercent.value, 0);

    var priority = (function () {
      var n = parseInt(mo.priorityField && mo.priorityField.value, 10);
      return isNaN(n) ? Infinity : n;
    })();

    var headline = (mo.headlineRef && mo.headlineRef.reference && mo.headlineRef.reference.template && mo.headlineRef.reference.template.value) || '';

    var checklist = [];
    try {
      checklist = JSON.parse((mo.checklistField && mo.checklistField.value) || '[]');
    } catch (e) {}

    var offer = {
      id: mo.id,
      offerType: offerType,
      discountPercent: discountPercent,
      priority: priority,
      headline: headline,
      checklist: checklist
    };

    if (offerType === 'bundle') {
      var pv = mo.primaryVariantRef && mo.primaryVariantRef.reference;
      if (!pv) return null;

      offer.bundleNode = {
        id: pv.id,
        availableForSale: pv.availableForSale,
        price: pv.price,
        compareAtPrice: pv.compareAtPrice,
        product: {
          title: pv.product && pv.product.title,
          handle: pv.product && pv.product.handle,
          featuredImage: pv.image || (pv.product && pv.product.featuredImage)
        }
      };
    }

    if (offerType === 'addon') {
      var refs = (mo.addonVariantsField && mo.addonVariantsField.references && mo.addonVariantsField.references.nodes) || [];
      offer.addonVariants = refs.filter(function (rv) { return rv && rv.availableForSale !== false; });
      if (!offer.addonVariants.length) return null;
    }

    return offer;
  }

  function offersFromMetafieldRefs(mf) {
    var refs = mf && mf.references && mf.references.nodes;
    if (!refs || !refs.length) return [];

    return refs.map(offerFromMetaobject).filter(Boolean);
  }

  // Variant-level custom.popup_offers (set on a specific shade) wins when
  // present, mirroring the custom.bundle_upsells precedence above.
  function offersFor(v) {
    var variantOffers = offersFromMetafieldRefs(v && v.variantOffers);
    if (variantOffers.length) return variantOffers;

    var product = v && v.product;
    return offersFromMetafieldRefs(product && product.productOffers);
  }

  // Best (lowest-priority) active addon-type offer for this variant, or null
  // when none apply. Used when no bundle cards exist for the variant.
  function getAddonOffer(v) {
    var offers = offersFor(v).filter(function (o) { return o.offerType === 'addon'; });
    if (!offers.length) return null;

    offers.sort(function (a, b) { return a.priority - b.priority; });
    return offers[0];
  }

  // Merges real Shopify Bundle components (native groupedBy), manually
  // tagged "fake" bundles (custom.bundle_upsells metafield) and metaobject-
  // driven bundle offers (custom.popup_offers, offer_type: "bundle") so the
  // popup fires for all three. Ordered by price, most expensive first (that
  // card is index 0 — the one that gets the "Best value" badge); ties
  // broken by original order so the sort stays stable.
  function getBundles(v) {
    if (!v) return [];

    var native = (v.groupedBy && v.groupedBy.nodes) || [];
    var manual = manualBundlesFromMetafield(v);
    var metaBundles = offersFor(v)
      .filter(function (o) { return o.offerType === 'bundle'; })
      .map(function (o) { return o.bundleNode; });

    var seen = {};
    var all = [];

    native.concat(manual).concat(metaBundles).forEach(function (b) {
      if (!b || b.availableForSale === false) return;

      var key = (b.product && b.product.handle) || numId(b.id);
      if (seen[key]) return;

      seen[key] = true;
      all.push(b);
    });

    all.forEach(function (b, i) { b._order = i; });

    all.sort(function (a, b) {
      var pa = numOrDefault(a.price && a.price.amount, -Infinity);
      var pb = numOrDefault(b.price && b.price.amount, -Infinity);
      if (pa !== pb) return pb - pa;
      return a._order - b._order;
    });

    return all;
  }

  // Joins native bundle component product titles for display under the
  // card name (e.g. "Bronzer + Blush + Liner"). Manual/fake bundles have
  // no `components` data in the Storefront API, so this returns '' for
  // them and the includes line is simply omitted.
  function bundleIncludesText(b) {
    var nodes = (b.components && b.components.nodes) || [];
    if (!nodes.length) return '';

    return nodes
      .map(function (c) {
        return (c.productVariant && c.productVariant.product && c.productVariant.product.title) || '';
      })
      .filter(Boolean)
      .join(' + ');
  }

  function syncBundleThumbPosition() {
    if (!root) return;

    var thumb = root.querySelector('.lbp-slide .lbp-thumb');
    var carouselEl = root.querySelector('.lbp-carousel');

    if (!thumb || !carouselEl) return;

    carouselEl.style.setProperty('--lbp-thumb-half', (thumb.offsetHeight / 2) + 'px');
  }

  function getCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    }).then(function (r) {
      return r.json();
    }).catch(function () {
      return null;
    });
  }

  // One "cart:refresh" on document is enough: the theme's m-cart-items
  // re-renders the drawer and opens it (detail.open), and free-shipping-bar,
  // promo-2-3, cart-upsell and cart-free-gifts all listen to this same event.
  // Firing it several times (plus window/Minimog duplicates) made the drawer
  // re-render repeatedly and "jump".
  function dispatchCartEvents(cart) {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        detail: { cart: cart, open: true }
      }));
    } catch (e) {}
  }

  function clickCartTrigger() {
    var selectors = [
      '[data-cart-drawer-open]',
      '[data-open-cart-drawer]',
      '[data-open-cart]',
      '[data-cart-trigger]',
      '[data-cart-toggle]',
      '.js-cart-drawer-open',
      '.js-open-cart',
      '.cart-drawer-open',
      '.cart-drawer-trigger'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);

      if (!el || root.contains(el)) continue;

      try {
        el.click();
        return true;
      } catch (e) {}
    }

    return false;
  }

  function openStickyCart(cart) {
    close();
    dispatchCartEvents(cart);

    // Fallback only: if the drawer did not open by itself, click the trigger.
    setTimeout(function () {
      var drawer = document.querySelector('m-cart-drawer');
      if (drawer && drawer.classList.contains('m-cart-drawer--active')) return;
      clickCartTrigger();
    }, 700);
  }

  function getBtnLabel(btn) {
    if (!btn) return '';

    if ('value' in btn && btn.value) {
      return btn.value;
    }

    return btn.textContent || '';
  }

  function setBtnLabel(btn, text) {
    if (!btn) return;

    if ('value' in btn) {
      btn.value = text;
    } else {
      btn.textContent = text;
    }
  }

  function setBtnLoading(btn, text) {
    if (!btn) return;

    if (!btn.dataset.lbpLabel) {
      btn.dataset.lbpLabel = getBtnLabel(btn);
    }

    btn.disabled = true;
    btn.setAttribute('data-lbp-loading', 'true');
    setBtnLabel(btn, text || t('adding', 'Adding...'));
  }

  function resetBtn(btn, text) {
    if (!btn) return;

    btn.disabled = false;
    btn.removeAttribute('data-lbp-loading');
    setBtnLabel(btn, text || btn.dataset.lbpLabel || t('addToCart', 'Add to cart'));
  }

  function addFormNormally(form, btn) {
    if (!form) return;

    setBtnLoading(btn, t('adding', 'Adding...'));
    var requestData = new FormData(form);
    var requested = [{ id: requestData.get('id'), quantity: Number(requestData.get('quantity')) || 1 }];
    var placement = window.LamelAnalytics && window.LamelAnalytics.placement(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body: requestData
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function (response) {
      if (window.LamelAnalytics) window.LamelAnalytics.cartAdded(response, { placement: placement }, requested);
      return getCart();
    }).then(function (cart) {
      resetBtn(btn);
      afterAdd(cart);
    }).catch(function () {
      resetBtn(btn, t('tryAgain', 'Try again'));
    });
  }

  function bundlePct(b) {
    if (b && b.compareAtPrice && parseFloat(b.compareAtPrice.amount) > parseFloat(b.price.amount)) {
      var pct = Math.round((1 - parseFloat(b.price.amount) / parseFloat(b.compareAtPrice.amount)) * 100);
      if (pct > 0) return pct;
    }

    return 0;
  }

  function updateTitlePct(b) {
    var pctEl = q('title-pct');
    if (!pctEl) return;

    var pct = bundlePct(b);

    pctEl.textContent = pct > 0 ? (' ' + pct + '%') : '';
  }

  function selectedBundle() {
    return state.bundles[state.selectedIdx];
  }

  // Dollar amount saved on a bundle card (real compareAtPrice minus real
  // price) — matches the addon block's "You save $X" (not a percent).
  function bundleSaveAmount(b) {
    if (!(b && b.compareAtPrice)) return '';

    var was = parseFloat(b.compareAtPrice.amount);
    var now = parseFloat(b.price && b.price.amount);
    if (isNaN(was) || isNaN(now) || !(was > now)) return '';

    return money({ amount: (was - now).toFixed(2), currencyCode: b.price.currencyCode });
  }

  function bundleCardMarkup(b) {
    var price = money(b.price);
    var was = b.compareAtPrice ? money(b.compareAtPrice) : '';
    var saveAmt = bundleSaveAmount(b);

    var imageUrl = b.product && b.product.featuredImage && b.product.featuredImage.url;
    var imageAlt = (b.product && b.product.featuredImage && b.product.featuredImage.altText) || (b.product && b.product.title) || '';
    var includes = bundleIncludesText(b);

    return (
      '<div class="lbp-thumb">' +
        '<img loading="lazy" src="' + esc(img(imageUrl, 500)) + '" alt="' + esc(imageAlt) + '">' +
      '</div>' +
      '<p class="lbp-name">' + esc((b.product && b.product.title) || '') + '</p>' +
      '<p class="lbp-includes' + (includes ? '' : ' lbp-includes--empty') + '">' + (includes ? esc(includes) : '&nbsp;') + '</p>' +
      '<div class="lbp-price-row">' +
        (was ? '<span class="lbp-was">' + esc(was) + '</span>' : '') +
        '<span class="lbp-price">' + esc(price) + '</span>' +
        (saveAmt ? '<span class="lbp-save">' + esc(t('youSave', 'You save')) + ' ' + esc(saveAmt) + '</span>' : '') +
      '</div>' +
      '<div class="lbp-spacer"></div>'
    );
  }

  function selectBundleByIndex(idx) {
    if (idx === state.selectedIdx) return;

    var track = q('track');
    var prevSlide = track.querySelector('[data-lbp-idx="' + state.selectedIdx + '"]');
    var nextSlide = track.querySelector('[data-lbp-idx="' + idx + '"]');

    if (prevSlide) prevSlide.classList.remove('lbp-card--selected');
    if (nextSlide) nextSlide.classList.add('lbp-card--selected');

    state.selectedIdx = idx;

    updateTitlePct(selectedBundle());
    updateFooterState(selectedBundle());
  }

  function bundleSlide(b, idx) {
    var slide = document.createElement('div');
    slide.className = 'lbp-slide lbp-card lbp-card--bundle';
    slide.setAttribute('role', 'button');
    slide.setAttribute('tabindex', '0');
    slide.setAttribute('data-lbp-idx', String(idx));

    if (idx === state.selectedIdx) {
      slide.classList.add('lbp-card--selected');
    }

    if (idx === 0) {
      slide.classList.add('lbp-card--best');
    }

    if (b.availableForSale === false) {
      slide.classList.add('lbp-card--soldout');
    }

    slide.innerHTML = bundleCardMarkup(b);

    function selectThis() {
      selectBundleByIndex(idx);
    }

    slide.addEventListener('click', selectThis);

    slide.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        selectThis();
      }
    });

    return slide;
  }

  function updateFooterState(b) {
    var addSetBtn = q('add-set');
    if (!addSetBtn) return;

    var unavailable = !b || b.availableForSale === false;

    addSetBtn.disabled = unavailable;

    if (unavailable) {
      addSetBtn.textContent = t('soldOut', 'Sold out');
      return;
    }

    var pct = bundlePct(b);
    addSetBtn.textContent = pct > 0
      ? renderTemplate(t('addSetSave', 'Yes, add my set — save {{ percent }}%'), { percent: pct })
      : t('addSet', 'Add set');
  }

  // Data order (state.bundles) is sorted by price, most expensive first
  // (best = index 0), and visual order now matches it exactly: the
  // best-value card shows first (leftmost), then the rest descending by
  // price.
  function displayOrder(n) {
    var order = [];
    for (var i = 0; i < n; i++) order.push(i);
    return order;
  }

  function renderCarousel() {
    var track = q('track');
    var dialog = root.querySelector('.lbp-dialog');
    track.innerHTML = '';

    var isSingle = state.bundles.length === 1;
    var isFixed = state.bundles.length === 2;

    track.classList.toggle('lbp-track--single', isSingle);
    track.classList.toggle('lbp-track--fixed', isFixed);

    if (dialog) dialog.classList.toggle('lbp-dialog--single', isSingle);

    displayOrder(state.bundles.length).forEach(function (idx) {
      track.appendChild(bundleSlide(state.bundles[idx], idx));
    });

    var n = state.bundles.length;

    carousel.count = n;
    carousel.idx = 0;

    q('nav').hidden = n <= 2;

    renderDots();
    updateTitlePct(selectedBundle());
    updateFooterState(selectedBundle());

    setTimeout(function () {
      syncBundleThumbPosition();
    }, 0);
  }

  function renderDots() {
    var dots = q('dots');
    dots.innerHTML = '';

    for (var i = 0; i < carousel.count; i++) {
      var d = document.createElement('span');
      d.className = 'lbp-dot';

      if (i === carousel.idx) {
        d.setAttribute('data-active', 'true');
      }

      dots.appendChild(d);
    }

    q('prev').disabled = carousel.idx <= 0;
    q('next').disabled = carousel.idx >= carousel.count - 1;
  }

  function slideStep() {
    var track = q('track');
    var slide = track.querySelector('.lbp-slide');
    if (!slide) return track.clientWidth;

    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;

    return slide.getBoundingClientRect().width + gap;
  }

  function goTo(i) {
    carousel.idx = Math.max(0, Math.min(i, carousel.count - 1));

    var track = q('track');

    track.scrollTo({
      left: slideStep() * carousel.idx,
      behavior: 'smooth'
    });

    renderDots();

    setTimeout(syncBundleThumbPosition, 50);
  }

  var popupTracking = null;
  var popupPlacement = 'product_page';

  function open(v, bundles) {
    var product = v.product || {};
    activeSourceHandle = product.handle || '';

    state.v = v;
    state.bundles = bundles;
    state.selectedIdx = 0;

    // Undo any openAddon() overrides (title/eyebrow/"No thanks" text) so a
    // regular bundle popup always looks exactly as before.
    addonState.awaiting = null;

    var titleEl = q('title');
    if (titleEl) titleEl.innerHTML = titleDefaultHTML;

    var eyebrowEl = q('eyebrow');
    if (eyebrowEl) eyebrowEl.textContent = eyebrowDefaultText;

    var addItemOnlyEl = q('add-item-only');
    if (addItemOnlyEl) addItemOnlyEl.textContent = addItemOnlyDefaultText;

    var track0 = q('track');
    track0.classList.remove('lbp-track--single');

    var dialog0 = root.querySelector('.lbp-dialog');
    if (dialog0) dialog0.classList.remove('lbp-dialog--single');

    renderCarousel();

    var addSetBtn = q('add-set');

    addSetBtn.onclick = function () {
      var b = selectedBundle();
      if (!b || b.availableForSale === false) return;

      addToCart(numId(b.id), {
        key: CFG.labelKey,
        val: CFG.labelValue
      }, b, addSetBtn);
    };

    var addItemBtn = q('add-item-only');

    addItemBtn.onclick = function () {
      addToCart(numId(v.id), null, null, addItemBtn);
    };

    var track = q('track');

    track.onscroll = function () {
      var step = slideStep();
      var i = step ? Math.round(track.scrollLeft / step) : 0;

      if (i !== carousel.idx) {
        carousel.idx = i;
        renderDots();
        setTimeout(syncBundleThumbPosition, 50);
      }
    };

    q('prev').onclick = function () {
      goTo(carousel.idx - 1);
    };

    q('next').onclick = function () {
      goTo(carousel.idx + 1);
    };

    lastFocus = document.activeElement;

    root.hidden = false;

    requestAnimationFrame(function () {
      root.setAttribute('data-open', 'true');
      if (popupTracking) popupTracking.view();
      setTimeout(syncBundleThumbPosition, 80);
    });

    document.documentElement.style.overflow = 'hidden';

    var closeBtn = root.querySelector('.lbp-close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });

    popupTracking = window.LamelAnalytics && window.LamelAnalytics.popup({
      type: 'bundle', id: 'bundle_recommendations', sourceProduct: activeSourceHandle, placement: popupPlacement
    });

    push('bundle_popup_view', {
      source_product: activeSourceHandle,
      variant_id: numId(v.id),
      bundles: bundles.length
    });
  }

  function close(method) {
    if (!root) return;
    if (popupTracking) popupTracking.close(method || 'programmatic');

    if (addonState.primaryPending) {
      var pending = addonState.primaryPending;
      addonState.primaryPending = null;

      pending.then(function (ok) {
        if (!ok) return;

        getCart().then(function (cart) {
          afterAdd(cart);
        });
      });
    }

    root.removeAttribute('data-open');
    document.documentElement.style.overflow = '';

    setTimeout(function () {
      root.hidden = true;
    }, 240);

    if (lastFocus && lastFocus.focus) {
      lastFocus.focus();
    }
  }

  function push(event, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({
        event: event
      }, data || {}));
    } catch (e) {}
  }

  function addToCart(variantId, prop, bundleNode, btn) {
    if (!variantId) return;

    var tracking = popupTracking;
    var confirmed = false;
    var action = bundleNode ? 'accept_bundle' : 'primary_only';
    if (tracking) tracking.select(action);
    var item = {
      id: Number(variantId),
      quantity: 1
    };

    if (prop) {
      item.properties = {};
      item.properties[prop.key] = prop.val;
    }
    if (tracking) item.properties = tracking.properties(item.properties, bundleNode ? 'bundle' : 'primary');

    setBtnLoading(btn, t('adding', 'Adding...'));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [item]
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function (response) {
      confirmed = true;
      if (tracking) tracking.added(response, action, [item]);
      if (bundleNode) {
        push('bundle_popup_add', {
          source_product: activeSourceHandle,
          bundle_handle: bundleNode.product && bundleNode.product.handle,
          bundle_title: bundleNode.product && bundleNode.product.title,
          value: bundleNode.price && parseFloat(bundleNode.price.amount),
          currency: bundleNode.price && bundleNode.price.currencyCode
        });
      } else {
        push('bundle_popup_add_single', {
          source_product: activeSourceHandle,
          variant_id: variantId
        });
      }

      return getCart();
    }).then(function (cart) {
      resetBtn(btn);
      if (tracking) tracking.close('added');
      afterAdd(cart);
    }).catch(function () {
      if (tracking) tracking.error(confirmed ? 'cart_refresh' : action);
      resetBtn(btn, t('tryAgain', 'Try again'));
    });
  }

  // Adds several line items (e.g. the trigger variant + a selected addon
  // shade) to the cart in a single request, for the addon-offer popup.
  function addItemsToCart(items, meta, btn) {
    if (!items || !items.length) return;
    var tracking = popupTracking;
    var confirmed = false;
    if (tracking) {
      tracking.select('accept_addon');
      items.forEach(function (item, index) {
        item.properties = tracking.properties(item.properties, index === items.length - 1 ? 'addon' : 'primary');
      });
    }

    setBtnLoading(btn, t('adding', 'Adding...'));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: items
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function (response) {
      confirmed = true;
      if (tracking) tracking.added(response, 'accept_addon', items);
      push('addon_popup_add', meta || {});
      return getCart();
    }).then(function (cart) {
      resetBtn(btn);
      if (tracking) tracking.close('added');
      afterAdd(cart);
    }).catch(function () {
      if (tracking) tracking.error(confirmed ? 'cart_refresh' : 'accept_addon');
      resetBtn(btn, t('tryAgain', 'Try again'));
    });
  }

  function renderTemplate(text, vars) {
    var out = String(text || '');
    if (!vars) return out;

    Object.keys(vars).forEach(function (name) {
      out = out.replace(new RegExp('{{\\s*' + name + '\\s*}}', 'g'), vars[name]);
    });

    return out;
  }

  // Display price for the addon offer, computed purely client-side from the
  // real variant price and the offer's discount_percent. Deliberately does
  // NOT use compareAtPrice — that would misrepresent the discount as a
  // sitewide markdown instead of one scoped to this specific combo.
  function addonPrice(variant, discountPercent) {
    var amount = parseFloat(variant && variant.price && variant.price.amount);
    if (isNaN(amount)) return { was: '', now: '' };

    var pct = discountPercent > 0 ? discountPercent : 0;
    var now = amount * (1 - pct / 100);

    return {
      was: money(variant.price),
      now: money({ amount: now.toFixed(2), currencyCode: variant.price.currencyCode })
    };
  }

  // Full price row on its own line below the product name (was / now /
  // "You save X%" — percent, unlike the classic bundle popup which shows a
  // dollar amount).
  function addonPriceRowHtml(variant, discountPercent) {
    var p = addonPrice(variant, discountPercent);
    var saveTxt = discountPercent > 0 ? (discountPercent + '%') : '';

    return (
      '<div class="lbp-price-row lbp-addon-block__price-row">' +
        (discountPercent > 0 ? '<span class="lbp-was">' + esc(p.was) + '</span>' : '') +
        '<span class="lbp-price">' + esc(p.now) + '</span>' +
        (saveTxt ? '<span class="lbp-save">' + esc(t('youSave', 'You save')) + ' ' + esc(saveTxt) + '</span>' : '') +
      '</div>'
    );
  }

  // Reuses the site-wide shade-swatch markup/classes (same as the PDP
  // "product-card style 4" swatches) so the addon block matches the rest of
  // the site without new CSS. Returns '' when there's nothing to choose
  // between (a single addon shade).
  //
  // Swatch image: mirrors card-color-swatches.liquid's own fallback order —
  // a custom-uploaded shade dot (Shopify File named "<handle>-<value>.png",
  // only for products tagged "swatch-files"; looked up server-side in Liquid
  // and exposed as window.__LBP_SWATCH_FILES since Storefront API can't
  // resolve Shopify Files by name) before falling back to the variant's own
  // product photo.
  // Chevron path shared with the classic popup's carousel prev/next arrows
  // (rotated 90deg via CSS to point up/down instead of left/right).
  var LBP_ARROW_SVG = '<svg viewBox="0 0 90 90" width="12" height="12" aria-hidden="true"><path d="M65.75 90c0.896 0 1.792-0.342 2.475-1.025c1.367-1.366 1.367-3.583 0-4.949L29.2 45L68.225 5.975c1.367-1.367 1.367-3.583 0-4.95c-1.367-1.366-3.583-1.366-4.95 0l-41.5 41.5c-1.367 1.366-1.367 3.583 0 4.949l41.5 41.5C63.958 89.658 64.854 90 65.75 90z" fill="currentColor"></path></svg>';

  // Same scroll-strip pattern as the site's own swatch carousel
  // (product-card-swatch.js): every dot renders into one scrollable track,
  // nav buttons just scroll it by one dot's worth at a time (not a page).
  // Whether nav is needed at all isn't decided here — the wrapper's actual
  // height comes from the photo (align-items: stretch, all the way down),
  // and updateAddonSwatchOverflow() measures after mount whether the dots
  // actually overflow that height, exactly like updateNav() does for the
  // real product card. Nav buttons are always in the markup (CSS hides them
  // by default) so that measurement sees the true available space.
  function addonSwatchesHtml(variants, selectedId) {
    if (!variants || variants.length < 2) return '';

    var fileMap = window.__LBP_SWATCH_FILES || {};

    var dots = variants.map(function (v) {
      var selected = String(v.id) === String(selectedId);
      var vid = numId(v.id);
      var customUrl = fileMap[vid];
      var bgUrl = customUrl || (v.image && img(v.image.url, 120));

      return (
        '<div class="m-product-option--node">' +
          '<button type="button" class="lamel-card-swatches__dot"' +
            (selected ? ' data-selected="true"' : '') +
            ' data-lbp-addon-variant="' + esc(vid) + '"' +
            ' aria-label="' + esc(v.title) + '"' +
            (bgUrl ? ' style="background-image:url(' + esc(bgUrl) + ')"' : '') +
          '></button>' +
        '</div>'
      );
    }).join('');

    return (
      '<div class="lamel-card-swatches-wrapper lbp-addon-swatches">' +
        '<button type="button" class="lbp-addon-swatches__nav lbp-addon-swatches__nav--up" data-lbp-addon-nav="up" aria-label="' + esc(t('prevSet', 'Previous shades')) + '">' + LBP_ARROW_SVG + '</button>' +
        '<div class="lamel-card-swatches-viewport" data-lbp-addon-viewport>' +
          '<div class="lamel-card-swatches-track">' +
            dots +
          '</div>' +
        '</div>' +
        '<button type="button" class="lbp-addon-swatches__nav lbp-addon-swatches__nav--down" data-lbp-addon-nav="down" aria-label="' + esc(t('nextSet', 'Next shades')) + '">' + LBP_ARROW_SVG + '</button>' +
      '</div>'
    );
  }

  // Mirrors product-card-swatch.js's getStep(): one dot's own size plus the
  // track gap, so a click moves exactly one swatch, never a whole page.
  function addonSwatchStep(viewport) {
    var track = viewport.querySelector('.lamel-card-swatches-track');
    var firstDot = track && track.querySelector('.lamel-card-swatches__dot');
    if (!firstDot) return 42;

    var gap = parseFloat(getComputedStyle(track).rowGap) || parseFloat(getComputedStyle(track).gap) || 6;
    return firstDot.getBoundingClientRect().height + gap;
  }

  // Pins the swatch wrapper's height to the photo's own rendered height —
  // a one-way read, done after the photo has already sized itself purely
  // from aspect-ratio, so nothing here can ever feed back and distort it
  // (that was the earlier bug with align-items: stretch, which let the
  // swatch column's own content decide the shared row height instead).
  // With a real, definite pixel height in place, ordinary flexbox
  // (viewport: flex: 1 1 auto; min-height: 0; overflow-y: auto) then
  // reliably sizes and clips the dot list — including automatically
  // shrinking the viewport once the nav buttons take their own space when
  // updateAddonSwatchOverflow() shows them — and the wrapper's
  // justify-content: center (see CSS) centers everything inside that
  // height when there's room to spare, instead of pinning it to the top.
  function syncAddonSwatchHeight(block) {
    var wrapper = block.querySelector('.lbp-addon-swatches');
    var media = block.querySelector('.lbp-addon-block__media');
    if (!wrapper || !media) return;

    var mediaHeight = media.getBoundingClientRect().height;
    if (!mediaHeight) return;

    wrapper.style.height = mediaHeight + 'px';
  }

  // Mirrors updateNav()'s hasOverflow check: nav only shows once the dots
  // genuinely don't fit the space the photo gave them. Measured with the
  // buttons still hidden (their default state), so the comparison is against
  // the full height the viewport would otherwise get — showing them then
  // only shrinks that space further, so the overflow verdict never flips
  // back once true.
  function updateAddonSwatchOverflow(block) {
    var wrapper = block.querySelector('.lbp-addon-swatches');
    var viewport = block.querySelector('[data-lbp-addon-viewport]');
    if (!wrapper || !viewport) return;

    var hasOverflow = viewport.scrollHeight > viewport.clientHeight + 1;
    wrapper.classList.toggle('lbp-addon-swatches--has-nav', hasOverflow);
  }

  function updateAddonSwatchNav(block) {
    var viewport = block.querySelector('[data-lbp-addon-viewport]');
    var prev = block.querySelector('.lbp-addon-swatches__nav--up');
    var next = block.querySelector('.lbp-addon-swatches__nav--down');
    if (!viewport || !prev || !next) return;

    var atStart = viewport.scrollTop <= 1;
    var atEnd = viewport.scrollTop + viewport.clientHeight >= viewport.scrollHeight - 1;

    prev.disabled = atStart;
    next.disabled = atEnd;
  }

  // Re-measures overflow and re-binds the scroll listener that keeps
  // disabled-state in sync; call after every block.innerHTML assignment,
  // since that destroys the previous viewport element (and its listener)
  // along with the old markup. restoreScrollTop carries the swatch list's
  // scroll position across a re-render (picking a shade rebuilds the whole
  // block, which would otherwise snap the list back to the top).
  function refreshAddonSwatchNav(block, restoreScrollTop) {
    var viewport = block.querySelector('[data-lbp-addon-viewport]');
    if (!viewport) return;

    syncAddonSwatchHeight(block);
    updateAddonSwatchOverflow(block);
    if (restoreScrollTop) viewport.scrollTop = restoreScrollTop;
    updateAddonSwatchNav(block);
    viewport.addEventListener('scroll', function () {
      updateAddonSwatchNav(block);
    }, { passive: true });
  }

  // Splits a headline like "Your gloss is set. Now hydrate underneath." into
  // two display lines at the first sentence boundary. Headlines without a
  // second sentence render on a single line.
  function splitHeadlineLines(text) {
    var str = String(text || '');
    var idx = str.indexOf('. ');
    if (idx === -1) return [str];

    return [str.slice(0, idx + 1), str.slice(idx + 2).trim()];
  }

  function renderAddonBlock(offer, selectedVariant) {
    var imageUrl = selectedVariant.image && selectedVariant.image.url;
    var imageAlt = (selectedVariant.image && selectedVariant.image.altText) || selectedVariant.title || '';
    var productTitle = (selectedVariant.product && selectedVariant.product.title) || selectedVariant.title || '';

    var checklistHtml = '';
    if (offer.checklist && offer.checklist.length) {
      checklistHtml = '<ul class="lbp-addon-checklist">' +
        offer.checklist.map(function (item) {
          return '<li class="lbp-addon-checklist__item">' + esc(item) + '</li>';
        }).join('') +
        '</ul>';
    }

    var swatchesHtml = addonSwatchesHtml(offer.addonVariants, selectedVariant.id);

    // Photo grows to fill the row (swatch column is a fixed narrow strip),
    // so photo+swatches together span almost the full popup width. Name and
    // price are separate stacked lines below, not sharing a row.
    return (
      '<div class="lbp-addon-block__top">' +
        '<div class="lbp-addon-block__media">' +
          '<img loading="lazy" src="' + esc(img(imageUrl, 500)) + '" alt="' + esc(imageAlt) + '">' +
        '</div>' +
        (swatchesHtml ? '<div class="lbp-addon-block__swatches-col">' + swatchesHtml + '</div>' : '') +
      '</div>' +
      '<p class="lbp-addon-block__title">' + esc(productTitle) + '</p>' +
      addonPriceRowHtml(selectedVariant, offer.discountPercent) +
      checklistHtml
    );
  }

  var addonState = { offer: null, variant: null, primaryPending: null, awaiting: null };

  // Addon popup: the trigger variant is NOT added when the popup opens.
  // It is added only after the customer decides:
  //  - "Add to order" -> trigger + addon go in one request, both tagged
  //    _bundle_source = bundle_addon_popup (see confirmBtn.onclick);
  //  - "No thanks" / X / overlay / Esc -> plain purchase of the trigger
  //    variant with NO _bundle_source property (see dismissAddon).
  function addPrimaryPlain(v, tracking) {
    var variantId = numId(v.id);
    var properties = tracking ? tracking.properties({}, 'primary') : {};

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: Number(variantId),
          quantity: 1,
          properties: properties
        }]
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function (response) {
      if (tracking) tracking.added(response, 'primary_only', [{ id: variantId, quantity: 1 }]);
      push('addon_popup_declined', {
        source_product: activeSourceHandle,
        variant_id: variantId
      });
      return true;
    }).catch(function () {
      if (tracking) tracking.error('primary_only');
      return false;
    });
  }

  // Customer dismissed the addon popup without accepting the offer
  // ("No thanks", X, overlay click, Esc): add the trigger variant as a
  // regular purchase and open the cart. For any other popup this is just close().
  function dismissAddon(method) {
    var tracking = popupTracking;
    var v = addonState.awaiting;
    addonState.awaiting = null;

    if (tracking && v) tracking.select('decline_addon');
    if (!v) {
      close(method || 'decline');
      return;
    }

    close(method || 'decline');

    addPrimaryPlain(v, tracking).then(function (ok) {
      if (!ok) return;

      getCart().then(function (cart) {
        afterAdd(cart);
      });
    });
  }

  // Parallel to open() for a variant whose bundle list is empty but that has
  // an active addon-type offer (custom.popup_offers). Reuses the same
  // dialog shell (root/overlay/focus/cart-drawer plumbing) but renders a
  // single addon block instead of the multi-card bundle carousel.
  function openAddon(v, offer) {
    var product = v.product || {};
    activeSourceHandle = product.handle || '';

    state.v = v;
    state.bundles = [];

    var track = q('track');
    var dialog = root.querySelector('.lbp-dialog');
    var titleEl = q('title');
    var eyebrowEl = q('eyebrow');

    track.innerHTML = '';
    track.classList.add('lbp-track--single');
    track.classList.remove('lbp-track--fixed');
    if (dialog) dialog.classList.add('lbp-dialog--single');

    var selectedVariant = offer.addonVariants[0];
    addonState.offer = offer;
    addonState.variant = selectedVariant;
    addonState.primaryPending = null;
    addonState.awaiting = v;

    var block = document.createElement('div');
    block.className = 'lbp-slide lbp-card lbp-card--selected lbp-addon-block';
    block.innerHTML = renderAddonBlock(offer, selectedVariant);
    track.appendChild(block);

    block.addEventListener('click', function (e) {
      var swatch = e.target.closest && e.target.closest('[data-lbp-addon-variant]');
      if (swatch) {
        var vid = swatch.getAttribute('data-lbp-addon-variant');
        var next = offer.addonVariants.filter(function (av) { return numId(av.id) === vid; })[0];
        if (!next) return;

        var prevViewport = block.querySelector('[data-lbp-addon-viewport]');
        var keepScrollTop = prevViewport ? prevViewport.scrollTop : 0;

        addonState.variant = next;
        block.innerHTML = renderAddonBlock(offer, next);
        refreshAddonSwatchNav(block, keepScrollTop);
        return;
      }

      var navBtn = e.target.closest && e.target.closest('[data-lbp-addon-nav]');
      if (navBtn) {
        if (navBtn.disabled) return;

        var viewport = block.querySelector('[data-lbp-addon-viewport]');
        if (!viewport) return;

        var dir = navBtn.getAttribute('data-lbp-addon-nav') === 'up' ? -1 : 1;
        viewport.scrollBy({ top: dir * addonSwatchStep(viewport), behavior: 'smooth' });
      }
    });

    q('nav').hidden = true;

    // Header stays the default "Complete the look — save X% today", just
    // populated with this offer's discount. The offer's own headline goes
    // where "Bundle offers" normally sits, split across two lines.
    if (titleEl) titleEl.innerHTML = titleDefaultHTML;

    var pctEl = q('title-pct');
    if (pctEl) pctEl.textContent = offer.discountPercent > 0 ? (' ' + offer.discountPercent + '%') : '';

    if (eyebrowEl) {
      // {{ percent }} in the headline = this offer's real discount_percent
      var headlineLines = splitHeadlineLines(renderTemplate(offer.headline, { percent: offer.discountPercent }));
      eyebrowEl.innerHTML = headlineLines.map(esc).join('<br>');
    }

    var confirmBtn = q('add-set');
    confirmBtn.textContent = renderTemplate(t('addToOrderSave', 'Add to order — save {{ percent }}%'), { percent: offer.discountPercent });

    confirmBtn.onclick = function () {
      var addonVariant = addonState.variant;
      if (!addonVariant || addonVariant.availableForSale === false) return;

      var pending = addonState.primaryPending || Promise.resolve(false);
      addonState.primaryPending = null;
      addonState.awaiting = null;

      setBtnLoading(confirmBtn, t('adding', 'Adding...'));

      pending.then(function (primaryAdded) {
        var items = [];

        if (!primaryAdded) {
          items.push({
            id: Number(numId(v.id)),
            quantity: 1,
            properties: { _bundle_source: 'bundle_addon_popup' }
          });
        }

        items.push({
          id: Number(numId(addonVariant.id)),
          quantity: 1,
          properties: {
            _bundle_source: 'bundle_addon_popup',
            _bundle_addon_source: activeSourceHandle
          }
        });

        addItemsToCart(items, {
          source_product: activeSourceHandle,
          addon_variant_id: numId(addonVariant.id),
          discount_percent: offer.discountPercent
        }, confirmBtn);
      });
    };

    var declineBtn = q('add-item-only');
    declineBtn.textContent = t('noThanksSimple', 'No thanks');

    declineBtn.onclick = function () {
      dismissAddon();
    };

    lastFocus = document.activeElement;

    root.hidden = false;

    requestAnimationFrame(function () {
      root.setAttribute('data-open', 'true');
      if (popupTracking) popupTracking.view();

      // Must run only after [data-open="true"] is actually set: #lbp-root is
      // "display: none" until that attribute lands (root.hidden = false
      // alone doesn't show it — see the CSS), so measuring the swatch
      // viewport any earlier reads clientHeight/scrollHeight as 0 and the
      // disabled-state check always concludes "already at the end,"
      // permanently disabling the down arrow until something else
      // (switching shades) re-renders and re-measures it correctly.
      refreshAddonSwatchNav(block);
    });

    document.documentElement.style.overflow = 'hidden';

    var closeBtn = root.querySelector('.lbp-close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });

    popupTracking = window.LamelAnalytics && window.LamelAnalytics.popup({
      type: 'addon', id: offer.id, sourceProduct: activeSourceHandle, placement: popupPlacement
    });

    push('addon_popup_view', {
      source_product: activeSourceHandle,
      variant_id: numId(v.id),
      offer_id: offer.id
    });
  }

  function afterAdd(cart) {
    if (CFG.afterAdd === 'none') {
      close();
      return;
    }

    if (CFG.afterAdd === 'reload') {
      location.reload();
      return;
    }

    if (CFG.afterAdd === 'cart') {
      location.href = '/cart';
      return;
    }

    openStickyCart(cart);
  }

  function getVariantIdFromForm(form) {
    if (!form) return '';

    var idField = form.querySelector('[name="id"]');
    if (!idField) return '';

    return idField.value || idField.getAttribute('value') || '';
  }

  function getAddButton(el) {
    if (!el || !el.closest) return null;

    return el.closest(
      '[name="add"], button[type="submit"], input[type="submit"], .product-form__submit, [data-add-to-cart], [data-atc], [data-product-add]'
    );
  }

  function handleAddClick(e) {
    try {
      if (!root) return;

      var btn = getAddButton(e.target);
      if (!btn || root.contains(btn)) return;

      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

      var form = btn.closest('form[action*="/cart/add"]');
      if (!form) return;

      popupPlacement = window.LamelAnalytics ? window.LamelAnalytics.placement(form) : 'unknown';
      var variantId = getVariantIdFromForm(form);
      if (!variantId) return;

      var cached = variantCache[String(variantId)];

      if (cached) {
        // Addon offers (custom.popup_offers) apply regardless of
        // requiresComponents: a native Shopify Bundle variant can still
        // carry a cross-sell addon offer. The classic bundle-of-bundles
        // popup (getBundles) stays skipped for such variants — nesting a
        // bundle picker on top of a variant that's already a bundle
        // doesn't make sense.
        var cachedAddon = getAddonOffer(cached);

        if (cachedAddon) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          openAddon(cached, cachedAddon);
          return;
        }

        if (cached.requiresComponents) return;

        var cachedBundles = getBundles(cached);
        if (!cachedBundles.length) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        open(cached, cachedBundles);
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      setBtnLoading(btn, t('checking', 'Checking...'));

      loadVariant(variantId).then(function (v) {
        resetBtn(btn);

        if (!v) {
          addFormNormally(form, btn);
          return;
        }

        var addonOffer = getAddonOffer(v);

        if (addonOffer) {
          openAddon(v, addonOffer);
          return;
        }

        if (v.requiresComponents) {
          addFormNormally(form, btn);
          return;
        }

        var bundles = getBundles(v);

        if (!bundles.length) {
          addFormNormally(form, btn);
          return;
        }

        open(v, bundles);
      });

    } catch (err) {}
  }

  function preloadFromInteraction(e) {
    try {
      if (!root) return;

      var btn = getAddButton(e.target);
      if (!btn || root.contains(btn)) return;

      var form = btn.closest('form[action*="/cart/add"]');
      if (!form) return;

      popupPlacement = window.LamelAnalytics ? window.LamelAnalytics.placement(form) : 'unknown';
      var variantId = getVariantIdFromForm(form);
      if (!variantId) return;

      loadVariant(variantId);
    } catch (err) {}
  }

  function bindUI() {
    root = document.getElementById('lbp-root');
    if (!root) return;

    var titleEl0 = q('title');
    if (titleEl0) titleDefaultHTML = titleEl0.innerHTML;

    var eyebrowEl0 = q('eyebrow');
    if (eyebrowEl0) eyebrowDefaultText = eyebrowEl0.textContent;

    var addItemOnlyEl0 = q('add-item-only');
    if (addItemOnlyEl0) addItemOnlyDefaultText = addItemOnlyEl0.textContent;

    root.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-lbp-close')) {
        dismissAddon(e.target.classList.contains('lbp-close') ? 'button' : 'backdrop');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.getAttribute('data-open') === 'true') {
        dismissAddon('escape');
      }
    });
  }

  function attach() {
    document.addEventListener('click', handleAddClick, true);

    document.addEventListener('pointerover', preloadFromInteraction, {
      capture: true,
      passive: true
    });

    document.addEventListener('touchstart', preloadFromInteraction, {
      capture: true,
      passive: true
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;

      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (form.dataset.lbpSubmitting === 'true') return;

      var submitter = document.activeElement;
      if (!submitter || root.contains(submitter)) return;

      popupPlacement = window.LamelAnalytics ? window.LamelAnalytics.placement(form) : 'unknown';
      var variantId = getVariantIdFromForm(form);
      if (!variantId) return;

      var cached = variantCache[String(variantId)];
      if (!cached) return;

      var addonOffer = getAddonOffer(cached);
      var bundles = [];

      if (!addonOffer) {
        if (cached.requiresComponents) return;

        bundles = getBundles(cached);
        if (!bundles.length) return;
      }

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (addonOffer) {
        openAddon(cached, addonOffer);
      } else {
        open(cached, bundles);
      }
    }, true);
  }

  function init() {
    bindUI();

    if (!root) return;

    if (!document.querySelector('form[action*="/cart/add"]')) return;

    attach();

    var lbpResizeQueued = false;

    function scheduleBundleThumbPositionSync() {
      if (lbpResizeQueued) return;

      lbpResizeQueued = true;

      requestAnimationFrame(function () {
        lbpResizeQueued = false;
        syncBundleThumbPosition();
      });
    }

    window.addEventListener('resize', scheduleBundleThumbPositionSync, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();